import { Path, useNavigate, useParams } from '@/router';

export function getDoohReportUrl(lineItemId: string): Path {
  return `/reporting/doohReport/${lineItemId}` as Path;
}

export function useDoohReportNavigation() {
  const { lineItemId } = useParams('/reporting/doohReport/:lineItemId');
  const navigate = useNavigate();

  const navigateToReport = (opts?: { newTab?: boolean }) => {
    const url = getDoohReportUrl(lineItemId);
    if (opts?.newTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }
    navigate(url);
  };

  return { lineItemId, navigateToReport };
}
